/**
 * LoadingFallback Component
 * 
 * Componente de carga mostrado durante el lazy loading de páginas.
 * Se utiliza como fallback en React.Suspense mientras se cargan
 * los chunks de las páginas bajo demanda.
 */

import React from 'react';
import './LoadingFallback.css';

export const LoadingFallback = () => {
  return (
    <div className="loading-fallback">
      <div className="loading-fallback__container">
        <div className="loading-fallback__spinner">
          <div className="loading-fallback__dot"></div>
          <div className="loading-fallback__dot"></div>
          <div className="loading-fallback__dot"></div>
        </div>
        <p className="loading-fallback__text">Cargando...</p>
      </div>
    </div>
  );
};

export default LoadingFallback;

